/* Order the entire filtered collection by product availability, then paginate.
 * The index contains only IDs and availability. Fetch card HTML only for the
 * native pages needed by the current view; preserve Shopify filters and sort.
 */
(function () {
  let controller;

  async function orderCollection() {
    if (controller) controller.abort();
    const page = document.querySelector('[data-stock-page]');
    const grid = page && page.querySelector('[data-stock-grid]');
    if (!grid) return;
    const base = new URL(window.location.href);
    // An explicit customer choice wins; otherwise promote best sellers (newest first in novedades).
    if (!base.searchParams.get('sort_by')) base.searchParams.set('sort_by', page.dataset.defaultSort || 'best-selling');
    const canReuseNativePage = page.dataset.nativeSort === base.searchParams.get('sort_by');
    const size = Number(page.dataset.pageSize);
    const total = Number(page.dataset.total);
    const currentPage = Number(page.dataset.page);
    const offset = (currentPage - 1) * size;
    if (!size || !total) return;
    controller = new AbortController();
    const signal = controller.signal;
    grid.setAttribute('aria-busy', 'true');

    async function getSection(section, number) {
      const url = new URL(base);
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', section);
      url.searchParams.set('page', number);
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error('Collection request failed');
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    }

    async function getIndex(number) {
      const doc = await getSection('4s-stock-index', number);
      const index = doc.querySelector('[data-stock-index]');
      if (!index) throw new Error('Missing stock index');
      return JSON.parse(index.textContent);
    }

    try {
      const first = await getIndex(1);
      const products = first.products;
      // Bound concurrency for larger collections.
      for (let number = 2; number <= first.pages; number += 3) {
        const batch = await Promise.all(Array.from(
          { length: Math.min(3, first.pages - number + 1) }, (_, i) => getIndex(number + i)
        ));
        batch.forEach(index => products.push(...index.products));
      }
      if (products.length !== total || new Set(products.map(p => p.id)).size !== total) {
        throw new Error('Collection changed during loading');
      }
      products.forEach((product, index) => { product.page = Math.floor(index / size) + 1; });
      const ordered = products.filter(p => p.available).concat(products.filter(p => !p.available));
      const selected = ordered.slice(offset, offset + size);
      const nativePages = [...new Set(selected.map(p => p.page))];
      const cards = new Map();
      function collect(element) {
        element.querySelectorAll('[data-stock-grid] > [data-product-id]').forEach(card => {
          cards.set(card.dataset.productId, card);
        });
      }
      if (canReuseNativePage) collect(page);
      for (let start = 0; start < nativePages.length; start += 3) {
        const docs = await Promise.all(nativePages.slice(start, start + 3)
          .filter(number => !canReuseNativePage || number !== currentPage)
          .map(number => getSection(page.dataset.section, number)));
        docs.forEach(collect);
      }
      if (signal.aborted || !grid.isConnected) return;
      if (selected.some(p => !cards.has(p.id))) throw new Error('Missing product cards');
      grid.replaceChildren(...selected.map(p => cards.get(p.id)));
      grid.dataset.stockOrdered = 'true';
      if (window.AOS) window.AOS.refreshHard();
    } catch (error) {
      // Keep the server-rendered page usable if a request fails or stock changes.
      if (error.name !== 'AbortError') console.warn('[Stock order]', error.message);
    } finally {
      if (!signal.aborted) grid.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('collection:reloaded', orderCollection);
  document.addEventListener('shopify:section:load', orderCollection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', orderCollection);
  else orderCollection();
})();
